import React from "react";
import { Button, Breadcrumb, Row, Col, Typography, Space } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
//import "antd/dist/antd.css";
import DataFetching from "./DataFetching";

export function AddInvoice() {
  const history = useHistory();
  const { Title } = Typography;
  return (
    <div>
      <Row className="titlt-part" align="middle">
        <Col xs={24} md={8}>
          <Title level={4}>Add Invoice</Title>
        </Col>
        <Col xs={24} md={16} className="text-right">
          <Space>
            <Breadcrumb>
              <Breadcrumb.Item href="/DashBoard">
                <span>Home</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/invoice/viewinvoices">
                <span>Invoice</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Add Invoice</Breadcrumb.Item>
            </Breadcrumb>
            {/* <Link to="/invoice/addinvoice"> */}
            <Button
              justify="end"
              type="primary"
              onClick={() => history.push("/invoice/viewinvoices")}
              icon={<EyeOutlined />}
              style={{ marginLeft: "auto" }}
            >
              View Invoice
            </Button>
            {/* </Link> */}
          </Space>
        </Col>
      </Row>

      <DataFetching />
    </div>
  );
}
